import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const BrandSection = () => {
  const brands = ["01.png", "02.png", "03.png", "04.png", "05.png", "06.png"];

  return (
    <div className="brand-section fix section-padding sect-bg pt-0">
      <div className="container">
        
        <p className="brand-text wow fadeInUp">
          Join Hands with Our Trusted Partners to Discover Exclusive Travel Experiences, 
          Unmatched Comfort, and Seamless Journeys Worldwide
        </p>

        <Swiper
          spaceBetween={30}
          slidesPerView={5}
          loop={true}
          autoplay={{ delay: 2000 }}
          breakpoints={{
            320: { slidesPerView: 2 },
            576: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            992: { slidesPerView: 5 },
          }}
        >
          {brands.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="brand-img text-center">
                <img
                  src={`/img/brand/${img}`}
                  alt={`brand-${index}`}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </div>
  );
};

export default BrandSection;